export function sort_arr(arr, n) {
    var num = Math.ceil(arr.length / n);
    var str_arr = new Array(num);
    for (var i = 0; i < num; i++) {
        str_arr[i] = [];
    }
    for (var i = 0; i < num; i++) {
        for (var j = 0; j < arr.length; j++) {
            if (i == 0) {
                if (j < n) {
                    arr[j].idx = j + 1;
                    str_arr[i].push(arr[j]);
                }
            } else {
                if (j < n * (1 + i) && j >= (n * i)) {
                    arr[j].idx = j + 1;
                    str_arr[i].push(arr[j]);
                }
            }
        }
    }
    return str_arr;
}

export function sort_arr_2(arr, n) {
    var num = Math.ceil(arr.length / n);
    var str_arr = new Array(num);
    for (var i = 0; i < num; i++) {
        str_arr[i] = [];
    }
    for (var i = 0; i < num; i++) {
        for (var j = 0; j < arr.length; j++) {
            if (i == 0) {
                if (j < n) {
                    str_arr[i].push(arr[j]);
                }
            } else {
                if (j < n * (1 + i) && j >= (n * i)) {
                    str_arr[i].push(arr[j]);
                }
            }
        }
    }
    return str_arr;
}
export function get_date(d_) {
    var d = new Date(d_);
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var date_ = d.getDate();
    if (month < 10) {
        month = "0" + month;
    }
    if (date_ < 10) {
        date_ = "0" + date_;
    }
    return year + "-" + month + "-" + date_;
}
export function setCookie(name, value, validTime) {
    var mesc = validTime * 60 * 1000;
    var exp = new Date();
    exp.setTime(exp.getTime() + mesc * 1);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}
export function delCookie(key) {
    var date = new Date();
    date.setTime(date.getTime() - 1);
    var delValue = getCookie(key);
    if (!!delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString();
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/public.js